<template>
  <div id="customer_login">
    <form @submit.prevent="submitForm">
      <div class="bg-white mb-2">
        <div class="form-shadow">
          <div class="row justify-content-center">
            <div class="col-lg-10" id="sells-s">
              <div class="otp-number">
                <div v-for="(input, index) in otpInputs" :key="index" class="form-group">
                  <input
                    type="tel"
                    class="form-control rounded-0 otp-control"
                    v-model="otpInputs[index]"
                    min="0"
                    max="9"
                    name="numericInput"
                    @keydown="handleKeydown(index, $event)"
                    ref="otpInput"
                    :ref="`otpInput${index}`"
                    maxlength="1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mb-4">
        <button type="submit" class="btn btn-primary fw-600 rounded-0 reg-btn" :disabled="loading">
          <span v-if="loading">Loading...</span>
          <span v-else>SUBMIT</span>
        </button>
      </div>
      <div class="row">
        <div class="col-6">
          <a href="/front/auth/forget_password">
            <p class="otp-text mb-4">OTP not received?</p>
          </a>
        </div>
      </div>
    </form>
  </div>
</template>


<script setup>
import { ref, nextTick } from 'vue';
import axios from 'axios';
import { resetPassword } from '../constant/auth.js';

const otpInputs = ref(['', '', '', '']);
const loading = ref(false);

const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};



const mobile = getQueryParam('mobile');

const handleKeydown = (index, event) => {
  if (event.key === 'Backspace') {
    if (otpInputs.value[index] === '') {
      if (index > 0) {
        nextTick(() => {
          document.querySelectorAll('.otp-control')[index - 1].focus();
        });
      }
    } else {
      otpInputs.value[index] = '';
    }
  } else if (event.key >= '0' && event.key <= '9') {
    otpInputs.value[index] = event.key;
    if (index < otpInputs.value.length - 1) {
      nextTick(() => {
        document.querySelectorAll('.otp-control')[index + 1].focus();
      });
    }
    event.preventDefault();
  }
};

const resetPasswordPath = resetPassword();

const submitForm = async () => {
  loading.value = true; // Start loading

  try {
    const otpResponse = await axios.post('otp-verify', {
      mobile: mobile,
      otp: otpInputs.value.join(''),
    });

    if (otpResponse.status === 200 && otpResponse.data.status === true) {
      window.successSnackbar(otpResponse.data.message);
      if (otpResponse.data.appUrl) {
        let redirectUrl = otpResponse.data.appUrl + '/' + resetPasswordPath.path + '?mobile=' + encodeURIComponent(mobile);
        window.location.href = redirectUrl;
      }
    } else {
      window.errorSnackbar(otpResponse.data.message);
    }
  } catch (error) {
    console.log('Error:', error);
    window.errorSnackbar(error.response.data.message || 'An error occurred');
  } finally {
    loading.value = false; // Stop loading
  }
};
</script>
